import type { AppRoute } from "@/lib/routing";

// Owner: C4 (formulas and compliance). Path as in spec §9.1.
export const routes: AppRoute[] = [
  {
    path: "/compliance",
    lazy: async () => ({ Component: (await import("./pages/CompliancePage")).CompliancePage }),
    handle: { title: "Compliance", keywords: ["IFRA", "allergens", "regulatory", "certificates", "max dosage"] },
  },
];
